import { Image as ImageIcon, Pencil, Trash2 } from "lucide-react";
import { TINTA, MARCA, ACCION, MONO } from "../constants.js";
import { fechaCorta } from "../lib/util.js";

/* ============================================================
   GALERÍA — cuadrícula de capturas con numeración REV-###.
   Cada tarjeta permite editar (reabre el Editor) o eliminar.
   ============================================================ */
export default function Galeria({
  capturas,
  cargando,
  onEditar,
  onEliminar,
  onIrNavegador,
}) {
  return (
    <div className="flex-1 overflow-auto p-4 sm:p-6">
      {cargando ? (
        <p className="text-center text-sm" style={{ color: "#5B6472" }}>
          Cargando capturas…
        </p>
      ) : capturas.length === 0 ? (
        <div className="h-full flex flex-col items-center justify-center gap-3 text-center">
          <ImageIcon size={44} style={{ color: "#9AA3B2" }} />
          <p className="font-semibold">La carpeta está vacía</p>
          <p className="text-sm max-w-sm" style={{ color: "#5B6472" }}>
            Captura o sube una imagen desde la pestaña Navegador y anótala;
            aparecerá aquí lista para el informe.
          </p>
          <button
            onClick={onIrNavegador}
            className="mt-1 px-4 py-2 rounded-lg text-sm font-semibold text-white"
            style={{ background: ACCION }}
          >
            Ir al navegador
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto">
          {capturas.map((c, i) => (
            <div
              key={c.id}
              className="bg-white rounded-xl overflow-hidden shadow-sm border flex flex-col"
              style={{ borderColor: "#E2E5EB" }}
            >
              <div
                className="px-3 py-1.5 text-[11px] text-white flex items-center justify-between"
                style={{ background: TINTA, fontFamily: MONO }}
              >
                <span>REV-{String(i + 1).padStart(3, "0")}</span>
                <span>{fechaCorta(c.fecha)}</span>
              </div>
              <img
                src={c.imagen}
                alt={c.titulo}
                className="w-full aspect-video object-cover object-top cursor-pointer"
                onClick={() => onEditar(c)}
              />
              <div className="p-3 flex-1 flex flex-col">
                <p className="font-semibold text-sm">{c.titulo}</p>
                {c.nota && (
                  <p className="text-xs mt-1 flex-1" style={{ color: "#5B6472" }}>
                    {c.nota}
                  </p>
                )}
                <div className="flex gap-2 mt-3">
                  <button
                    onClick={() => onEditar(c)}
                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 rounded-lg text-xs font-medium border"
                    style={{ borderColor: "#CBD2DC", color: TINTA }}
                  >
                    <Pencil size={13} /> Editar
                  </button>
                  <button
                    onClick={() => onEliminar(c.id)}
                    className="px-2.5 py-1.5 rounded-lg text-xs border"
                    title="Eliminar"
                    style={{ borderColor: "#CBD2DC", color: MARCA }}
                  >
                    <Trash2 size={13} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
